import ContactForm from '../components/ContactForm'

function Contact() {
  return <main>
    <section className="own_story custom-space">
      <div className="container">
        <div className="row">
          <div className="col-md-6 ">
            <h2 className="custom-heading-contact">Have a question?
              <br /> <span> Get in touch with us.</span>
            </h2>
            <p className="sub-content-contact">We at Bajaj Capital Insurance are always happy to help our people
              and provide an exceptional service</p>

            <p className="enq-contact">Partner Service Enquiries</p>
            <a href="#">
              <p className="info-contact">1800-212-123123</p>
            </a>

            <p className="enq-contact">General Enquiries</p>

            <a href="#"><p className="info-contact"> care[at]bajajcapital[dot]com</p></a>
          </div>
          <div className="col-md-5 offset-md-1">
            {/* classform */}
            <ContactForm />

          </div>
          <div class="col-md-12">

            <iframe
              className="w-100 custom-map"
              src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d224354.17448168295!2d77.0041323!3d28.5236656!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390ce3cf8bdaaaab%3A0x48b644fbdcd3c491!2sBajaj%20Capital%20Insurance%20Broking%20Ltd!5e0!3m2!1sen!2sin!4v1662034951362!5m2!1sen!2sin"
              width="600"
              height="450"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />


          </div>
        </div>
      </div>
    </section>
  </main>;
}

export default Contact;
